import { FormBase } from 'core/components';

export default class PatientEditModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'ssn',
                    label: 'SSN',
                    placeholder: 'Enter SSN',
                },
                {
                    name: 'height',
                    label: 'Height (in.)',
                    placeholder: 'Enter Height (in.)'           
                },
                {
                    name: 'weight',
                    label: 'Weight (lbs.)',
                    placeholder: 'Enter Weight (lbs.)'                  
                }
            ],
        };
    }
}
